import React from 'react';
import styled from 'styled-components';
import { cornerStyleInterpolationFactory } from '../lib/cornerStyle';
import { SkeletonBlock, SkeletonText } from '@nucleus/web-theme-elements';

export const PostGridItemSkeleton = (): JSX.Element => {
  return (
    <Container>
      <ThumbnailPlaceholder />
      <Meta>
        <SkeletonText width="30%" style={{ height: 10, marginBottom: 8 }} />
        <SkeletonText width="80%" style={{ height: 16, marginBottom: 6 }} />
        <SkeletonText width="60%" style={{ height: 16, marginBottom: 12 }} />
        <SkeletonText width="90%" style={{ height: 12, marginBottom: 4 }} />
        <SkeletonText width="70%" style={{ height: 12 }} />
      </Meta>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 12.5px;
  aspect-ratio: 340 / 420;
  width: 100%;
  border-radius: ${cornerStyleInterpolationFactory({
    square: '0px',
    rounded: '12px',
    pill: '25px',
  })};
`;

const ThumbnailPlaceholder = styled(SkeletonBlock)`
  width: 100%;
  flex: 1 1 auto;
  border-radius: ${cornerStyleInterpolationFactory({
    square: '0px',
    rounded: '10px',
    pill: '18px',
  })};
`;

const Meta = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 6px;
  padding-bottom: 6px;
`;
